import { drawInterval, hidePacRetirementLine, updateRetirementCheckboxes } from "../main";

export function animateRetirementGraph(graph, oldCheckboxes, newCheckboxes, data, options) {
    const keys = Object.keys(newCheckboxes);

    keys.forEach((k, i) => {
        if (k !== "showAll" && newCheckboxes[k] && !oldCheckboxes[k]) {
            animateOneUp(k, i, graph, data, newCheckboxes, options);
        } else if (
            k !== "showAll" &&
            !newCheckboxes[k] &&
            oldCheckboxes[k] &&
            (k !== "pac" || (k === "pac" && !hidePacRetirementLine))
        ) {
            animateOneDown(k, i, graph, data, newCheckboxes, options);
        }
    });
}

function findBottom(k, data, newCheckboxes) {
    const zeroArray = [0, 0, 0];

    if (k === "noPAC") {
        return zeroArray;
    } else if (k === "noAnnualIncrease") {
        if (newCheckboxes.noPAC) {
            return data.noPAC.points.map((point) => point.y);
        } else {
            return zeroArray;
        }
    } else {
        if (newCheckboxes.noAnnualIncrease) {
            return data.noAnnualIncrease.points.map((point) => point.y);
        } else if (newCheckboxes.noPAC) {
            return data.noPAC.points.map((point) => point.y);
        } else {
            return zeroArray;
        }
    }
}

function animateOneDown(k, index, graph, data, newCheckboxes, options) {
    let oldY = graph.lines[index].points.map((point) => point.y);

    let tempY;

    const bottomY = findBottom(k, data, newCheckboxes);

    const intervals = oldY.map((yValue, i) => (yValue - bottomY[i]) / (drawInterval / 1.5));

    let time = performance.now();

    const animateDown = () => {
        const intervalAmount = Math.round((performance.now() - time) / (drawInterval / 1.5));

        tempY = oldY.map((y, i) => y - intervals[i] * intervalAmount);

        data[k].points.map((point, i) => (point.y = tempY[i]));

        if (tempY[0] <= bottomY[0]) {
            data[k].points.map((point) => (point.y = 0));

            updateRetirementCheckboxes(newCheckboxes);

            graph.clearLines();
            graph.addLine(data.pac);
            graph.addLine(data.noAnnualIncrease);
            graph.addLine(data.noPAC);
            graph.setOptions(options.axes, options.styles, options.hooks);
            graph.draw();
            clearInterval(animateDown);
        } else {
            window.requestAnimationFrame(animateDown);
            graph.clearLines();
            graph.addLine(data.pac);
            graph.addLine(data.noAnnualIncrease);
            graph.addLine(data.noPAC);
            graph.setOptions(options.axes, options.styles, options.hooks);
            graph.draw();
        }
    };
    window.requestAnimationFrame(animateDown);
}

function animateOneUp(k, index, graph, data, newCheckboxes, options) {
    const newY = data[k].points.map((point) => point.y);

    let tempY;

    let bottomY = findBottom(k, data, newCheckboxes);

    const intervals = newY.map((yValue, i) => (yValue - bottomY[i]) / drawInterval);

    updateRetirementCheckboxes(newCheckboxes);

    let time = performance.now();

    const animateUp = () => {
        const intervalAmount = Math.round((performance.now() - time) / (drawInterval / 1.5));

        tempY = bottomY.map((y, i) => {
            return y + intervals[i] * intervalAmount;
        });

        data[k].points.map((point, i) => {
            point.y = tempY[i];
        });

        if (tempY[0] >= newY[0]) {
            data[k].points.map((point, i) => (point.y = newY[i]));

            graph.clearLines();
            graph.addLine(data.pac);
            graph.addLine(data.noAnnualIncrease);
            graph.addLine(data.noPAC);
            graph.setOptions(options.axes, options.styles, options.hooks);
            graph.draw();
            clearInterval(animateUp);
        } else {
            window.requestAnimationFrame(animateUp);
            graph.clearLines();
            graph.addLine(data.pac);
            graph.addLine(data.noAnnualIncrease);
            graph.addLine(data.noPAC);
            graph.setOptions(options.axes, options.styles, options.hooks);
            graph.draw();
        }
    };

    window.requestAnimationFrame(animateUp);
}
